"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LayoutModule: ['layout-module', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.250 0.247 L6.750 0.247 L6.750 6.747 L0.250 6.747 Z', 'M0.250 8.747 L6.750 8.747 L6.750 15.247 L0.250 15.247 Z', 'M0.250 17.247 L6.750 17.247 L6.750 23.747 L0.250 23.747 Z', 'M8.750 0.247 L15.250 0.247 L15.250 6.747 L8.750 6.747 Z', 'M8.750 8.747 L15.250 8.747 L15.250 15.247 L8.750 15.247 Z', 'M8.750 17.247 L15.250 17.247 L15.250 23.747 L8.750 23.747 Z', 'M17.250 0.247 L23.750 0.247 L23.750 6.747 L17.250 6.747 Z', 'M17.250 8.747 L23.750 8.747 L23.750 15.247 L17.250 15.247 Z', 'M17.250 17.247 L23.750 17.247 L23.750 23.747 L17.250 23.747 Z']],
  Layout1: ['layout-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2.5,8h4a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,2.5,8ZM9,21.5V8.5A.5.5,0,0,1,9.5,8h12a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H9.5A.5.5,0,0,1,9,21.5Z']],
  LayoutContentAlternate: ['layout-content-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,0H3A3,3,0,0,0,0,3V8a3,3,0,0,0,3,3H8a3,3,0,0,0,3-3V3A3,3,0,0,0,8,0ZM9,8A1,1,0,0,1,8,9H3A1,1,0,0,1,2,8V3A1,1,0,0,1,3,2H8A1,1,0,0,1,9,3Z', 'M8,13H3a3,3,0,0,0-3,3v5a3,3,0,0,0,3,3H8a3,3,0,0,0,3-3V16A3,3,0,0,0,8,13Zm1,8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1Z', 'M14.246,3h9a.75.75,0,0,0,0-1.5h-9a.75.75,0,1,0,0,1.5Z', 'M23.249,4.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M23.249,7.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,1,0,0-1.5Z', 'M23.249,14.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M23.249,17.5h-9a.75.75,0,1,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M23.249,20.5h-9a.75.75,0,1,0,0,1.5h9a.75.75,0,0,0,0-1.5Z']],
  Layout3: ['layout-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5Zm-7,6v13a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,9.5,8h5A.5.5,0,0,1,15,8.5ZM2.5,8h4a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,2.5,8ZM17,21.5V8.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,17,21.5Z']],
  Layout4: ['layout-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2.5,8h8a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,2.5,8ZM13,21.5V8.5a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-8A.5.5,0,0,1,13,21.5Z']],
  Layout5: ['layout-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM9.5,8h12a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,9.5,8ZM22,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2.5,8h4a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,2.5,8ZM9,21.5v-5a.5.5,0,0,1,.5-.5h12a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H9.5A.5.5,0,0,1,9,21.5Z']],
  LayoutArray1: ['layout-array-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.500 0.997 L17.500 0.997 L17.500 22.997 L6.500 22.997 Z', 'M0.000 2.497 L4.500 2.497 L4.500 21.497 L0.000 21.497 Z', 'M19.500 2.497 L24.000 2.497 L24.000 21.497 L19.500 21.497 Z']],
  LayoutBullets: ['layout-bullets', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 0.747 L5.500 0.747 L5.500 6.247 L-0.000 6.247 Z', 'M0.000 9.247 L5.500 9.247 L5.500 14.747 L-0.000 14.747 Z', 'M0.000 17.747 L5.500 17.747 L5.500 23.247 L-0.000 23.247 Z', 'M8.500 0.747 L24.000 0.747 L24.000 6.247 L8.500 6.247 Z', 'M8.500 9.247 L24.000 9.247 L24.000 14.747 L8.500 14.747 Z', 'M8.500 17.747 L24.000 17.747 L24.000 23.247 L8.500 23.247 Z']],
  LayoutHeadline: ['layout-headline', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 0.747 L24.000 0.747 L24.000 6.247 L0.000 6.247 Z', 'M0.000 9.247 L24.000 9.247 L24.000 14.747 L0.000 14.747 Z', 'M0.000 17.747 L24.000 17.747 L24.000 23.247 L0.000 23.247 Z']],
  LayoutNone: ['layout-none', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM21,22H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21a1,1,0,0,1,1,1V21A1,1,0,0,1,21,22Z']],
  LayoutRight: ['layout-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM2.5,2h12a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2Zm19,20h-4a.5.5,0,0,1-.5-.5V2.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v19A.5.5,0,0,1,21.5,22Z']],
  LayoutModule2: ['layout-module-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2Zm-2.5,9h-8a.5.5,0,0,1-.5-.5v-8a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v8A.5.5,0,0,1,21.5,11ZM11,2.5v8a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,2.5,2h8A.5.5,0,0,1,11,2.5ZM2.5,13h8a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,2.5,13ZM13,21.5v-8a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-8A.5.5,0,0,1,13,21.5Z']],
  LayoutTwoColums: ['layout-two-colums', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM2.5,2h8a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2Zm19,20h-8a.5.5,0,0,1-.5-.5V2.5a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v19A.5.5,0,0,1,21.5,22Z']],
  LayoutColumn: ['layout-column', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.250 0.497 L6.750 0.497 L6.750 23.497 L0.250 23.497 Z', 'M8.750 0.497 L15.250 0.497 L15.250 23.497 L8.750 23.497 Z', 'M17.250 0.497 L23.750 0.497 L23.750 23.497 L17.250 23.497 Z']],
  LayoutArray: ['layout-array', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.500 2.497 L17.500 2.497 L17.500 21.497 L6.500 21.497 Z', 'M0.000 2.497 L4.500 2.497 L4.500 21.497 L0.000 21.497 Z', 'M19.500 2.497 L24.000 2.497 L24.000 21.497 L19.500 21.497 Z']],
  LayoutModule1: ['layout-module-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 -0.003 L11.000 -0.003 L11.000 10.997 L-0.000 10.997 Z', 'M13.000 -0.003 L24.000 -0.003 L24.000 10.997 L13.000 10.997 Z', 'M0.000 12.997 L11.000 12.997 L11.000 23.997 L-0.000 23.997 Z', 'M13.000 12.997 L24.000 12.997 L24.000 23.997 L13.000 23.997 Z']],
  LayoutAgenda: ['layout-agenda', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 1.997 L24.000 1.997 L24.000 10.997 L0.000 10.997 Z', 'M0.000 12.997 L24.000 12.997 L24.000 21.997 L0.000 21.997 Z']],
  Layout2: ['layout-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM2.5,8h8a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,2.5,8Zm11,0h8a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,13.5,8ZM22,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2.5,16h8a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-5A.5.5,0,0,1,2.5,16ZM13,21.5v-5a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5h-8A.5.5,0,0,1,13,21.5Z']],
  Layout6: ['layout-6', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2.5,8h12a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,2.5,8ZM17,21.5V8.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,17,21.5Z']],
  LayoutLeft: ['layout-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM2.5,2h4a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2Zm19,20H9.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,9.5,2h12a.5.5,0,0,1,.5.5v19A.5.5,0,0,1,21.5,22Z']],
  LayoutContent: ['layout-content', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.500 0.997 L10.500 0.997 L10.500 10.997 L0.500 10.997 Z', 'M0.500 12.997 L10.500 12.997 L10.500 22.997 L0.500 22.997 Z', 'M13.747,3h9a.75.75,0,0,0,0-1.5h-9a.75.75,0,0,0,0,1.5Z', 'M22.75,4.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M22.75,7.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M22.75,14.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M22.75,17.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z', 'M22.75,20.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z']],
  LayoutTop: ['layout-top', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,2.5v3a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,5.5v-3A.5.5,0,0,1,2.5,2h19A.5.5,0,0,1,22,2.5ZM2,21.5V8.5A.5.5,0,0,1,2.5,8h19a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,21.5Z']],
  LayoutThreeColumns: ['layout-three-columns', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM15,2.5v19a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,9.5,2h5A.5.5,0,0,1,15,2.5ZM2.5,2h4a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2Zm19,20h-4a.5.5,0,0,1-.5-.5V2.5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v19A.5.5,0,0,1,21.5,22Z']],
  Layout: ['layout', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.5,11H8.5a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,8.5,2h13a.5.5,0,0,1,.5.5v8A.5.5,0,0,1,21.5,11ZM2.5,2h3a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2ZM8,21.5v-8a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5H8.5A.5.5,0,0,1,8,21.5Z']]
};
exports["default"] = _default;